import React from "react";
import { NavLink } from "react-router-dom";
import { estRouteActive } from "./visibiliteMenu";

// Une entrée du menu : icône + libellé (masqué visuellement en rail, gardé
// pour les lecteurs d'écran) + infobulle en rail. NavLink pose
// aria-current="page" sur la route active ; `data-priv` reste lu par RoleStyle.
// `cheminActif` : chemin de l'entrée courante choisie par le menu
// (entreeActive) ; sans lui, l'entrée se juge seule sur la route.
const ElementMenu = ({ item, infobulle = false, sousEntree = false, cheminActif }) => (
  <li>
    <NavLink
      to={item.path}
      exact={item.path === "/"}
      isActive={(match, location) =>
        cheminActif === undefined ? estRouteActive(item.path, location.pathname) : item.path === cheminActif
      }
      className={"menu-lateral__item" + (sousEntree ? " menu-lateral__item--sous" : "")}
      data-priv={item.dataPriv || undefined}
    >
      <i className={`fa fa-${item.icon}`} aria-hidden="true" />
      <span className="menu-lateral__libelle">{item.name}</span>
      {infobulle && (
        <span className="menu-lateral__bulle" aria-hidden="true">
          {item.name}
        </span>
      )}
    </NavLink>
  </li>
);

export default ElementMenu;
